import React from "react";
import { ListItem, ListItemAvatar, Avatar, Badge } from "@mui/material";

// helpers
const truncate = (str = "", n = 42) =>
  str.length > n ? `${str.slice(0, n)}…` : str;

const timeStr = (ts) =>
  ts ? new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "";

const isUnreadFor = (convo, currentUser) => {
  const um1 = Number(convo?.UnreadMessagesUser1 || 0);
  const um2 = Number(convo?.UnreadMessagesUser2 || 0);
  if (String(currentUser) === String(convo?.User1Id)) return um1 > 0;
  if (String(currentUser) === String(convo?.User2Id)) return um2 > 0;
  return (um1 + um2) > 0;
};

const initialsOf = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() || "")
    .join("");

const ConversationItem = ({
  convo = {},
  currentUser,
  selectedConversation,
  onSelectConversation,
}) => {
  const title =
    convo.PartnerName || convo.ShowName || convo.RecipientName || "User";

  const avatarSrc =
    convo.PartnerAvatar || convo.ProfilPicture || convo.RecipientAvatar || null;

  const lastMsg = truncate(convo?.LastMessage || "");
  const lastTime = timeStr(convo?.LastMessageTimestamp);

  const unread = isUnreadFor(convo, currentUser);

  const isSelected =
    (selectedConversation?.ConversationId && convo?.ConversationId &&
      String(selectedConversation.ConversationId) === String(convo.ConversationId)) ||
    (selectedConversation?.id && convo?.id &&
      String(selectedConversation.id) === String(convo.id));

  return (
    <ListItem
      button
      selected={Boolean(isSelected)}
      onClick={() => onSelectConversation && onSelectConversation(convo)}
      className={`conversation-item2 ${isSelected ? "is-selected" : ""}`}
      disableGutters
    >
      <ListItemAvatar className="ci-avatarWrap">
        <Badge
          color="primary"
          variant={unread ? "dot" : undefined}
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Avatar src={avatarSrc || undefined} alt={title} className="ci-avatar">
            {!avatarSrc ? initialsOf(title) : null}
          </Avatar>
        </Badge>
      </ListItemAvatar>

      <div className="ci-content">
        <div className="ci-meta">
          <span className={`ci-name ${unread ? "is-unread" : ""}`} title={title}>
            {title}
          </span>
          {lastTime && <span className="ci-time">{lastTime}</span>}
        </div>

        <div className={`ci-preview ${unread ? "is-unread" : ""}`}>
          {lastMsg || "\u00A0" /* keep height even if empty */}
        </div>
      </div>
    </ListItem>
  );
};

export default ConversationItem;
